import { useTranslation } from "react-i18next";
import {
  Wrap,
  Card,
  TitleRow,
  Title,
  Badge,
  Divider,
  List,
  Item,
  Icon,
  Strong,
  Note,
  Quote,
  Manager,
} from "./InfoDeliveryStyles";

export default function InfoDelivery({ className, validFrom = "27-01-2025" }) {
  const { t } = useTranslation();

  const txt = {
    title: t("delivery.title"),
    badge: t("delivery.badge"),
    hoursTitle: t("delivery.hoursTitle"),
    hours: t("delivery.hours"),
    freeInPredeal: t("delivery.freeInPredeal"),
    minOrder: t("delivery.minOrder"),
    over2km: t("delivery.over2km"),
    pricesChange: t("delivery.pricesChange"),
    validLabel: t("delivery.validLabel"),
    quote: t("delivery.quote"),
    manager: t("delivery.manager"),
  };

  return (
    <Wrap className={className} aria-labelledby="delivery-title">
      <Card>
        <TitleRow>
          <Title id="delivery-title">{txt.title}</Title>
          <Badge>{txt.badge}</Badge>
        </TitleRow>

        <Divider />

        <List>
          <Item>
            <Icon viewBox="0 0 24 24" aria-hidden="true">
              <path d="M12 7a1 1 0 0 1 1 1v3.18l2.1 2.1a1 1 0 1 1-1.4 1.42l-2.4-2.4A1 1 0 0 1 11 12V8a1 1 0 0 1 1-1Z" />
              <path
                d="M12 22a10 10 0 1 1 0-20 10 10 0 0 1 0 20Z"
                fill="none"
                strokeWidth="1.5"
              />
            </Icon>
            <div>
              <Strong>{txt.hoursTitle}:</Strong> {txt.hours}
            </div>
          </Item>

          <Item>
            <Icon viewBox="0 0 24 24" aria-hidden="true">
              <path d="M3 13h2l2 3h9l3-7h-8" fill="none" strokeWidth="1.5" />
              <circle cx="7" cy="19" r="2" />
              <circle cx="17" cy="19" r="2" />
            </Icon>
            <div>{txt.freeInPredeal}</div>
          </Item>

          <Item>
            <Icon viewBox="0 0 24 24" aria-hidden="true">
              <path
                d="M12 3v18M5 7h14M5 12h14M5 17h14"
                fill="none"
                strokeWidth="1.5"
              />
            </Icon>
            <div>{txt.minOrder}</div>
          </Item>

          <Item>
            <Icon viewBox="0 0 24 24" aria-hidden="true">
              <path d="M4 12h16" strokeWidth="1.5" />
              <path
                d="M4 12a8 8 0 0 0 16 0 8 8 0 0 0-16 0Z"
                fill="none"
                strokeWidth="1.5"
              />
              <circle cx="12" cy="12" r="2" />
            </Icon>
            <div>{txt.over2km}</div>
          </Item>

          <Item>
            <Icon viewBox="0 0 24 24" aria-hidden="true">
              <path
                d="M4 7h16M7 7v10a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V7"
                fill="none"
                strokeWidth="1.5"
              />
              <path
                d="M10 7V5a2 2 0 0 1 2-2h0a2 2 0 0 1 2 2v2"
                fill="none"
                strokeWidth="1.5"
              />
            </Icon>
            <div>{txt.pricesChange}</div>
          </Item>
        </List>

        <Note>
          <span>
            *** {txt.validLabel} {validFrom} ***
          </span>
        </Note>

        <Divider soft />

        <Quote>
          <span aria-hidden="true">“</span>
          {txt.quote}
        </Quote>
        <Manager>{txt.manager}</Manager>
      </Card>
    </Wrap>
  );
}
